import React from "react";
import styled from "@emotion/styled";
import Backdrop from "components/Backdrop";

interface IProps {
  modalClosed: any;
  show: boolean;
}

const StyledModal = styled.div<{ show: boolean }>(({ show }) => ({
  position: "absolute",
  top: "50%",
  left: "50%",
  zIndex: 500,
  backgroundColor: "white",
  textAlign: "center",
  padding: "20px 20px",
  borderRadius: "6px",
  boxSizing: "border-box",
  boxShadow: "0px 4px 12px rgba(21, 20, 153, 0.16)",
  transition: "all 0.3s ease-out",
  // overflow: "hidden", //TODO: This may be required, but breaks StyledSelect's options/dropdown
  // border: "2px solid #263238",
  transform: "translate(-50%, -50%)",
  display: show ? "block" : "none",
  width: "34%",
}));

const Modal: React.FC<IProps> = ({ modalClosed, show, children }) => {
  return (
    <>
      {show && <Backdrop onClick={modalClosed} />}
      <StyledModal show={show}>{children}</StyledModal>
    </>
  );
};

export default Modal;
